import userService from "../../services/user.service";
import {
  ActionTypes,
  VideoLibraryDataTableActionTypes,
} from "../Constants/ActionTypes";

export const setMaximizeLibraryPage = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.MAXIMIZE_LIBRARY_PAGE,
    payload: payload,
  });
};

export const setInSeasonVideoData = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_INSEASON_DATA,
    payload: payload,
  });
};

export const setEditedVideoData = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_EDITED_VIDEO_DATA,
    payload: payload,
  });
};

export const setOffSeasonVideoData = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_OFFSEASON_DATA,
    payload: payload,
  });
};

export const setOtherSeasonVideoData = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.SET_OTHERSEASON_DATA,
    payload: payload,
  });
};

export const renameVideo = async (dispatch, payload) => {
  // Destructure required fields from payload
  const {
    videoId,
    videoName,
    schoolId,
    playlistId,
    selectedVideoPaths,
    loading,
    isVideoFromLibrary,
  } = payload;

  try {
    dispatch({
      type: ActionTypes.RENAME_VIDEO_LOADING,
      payload: loading,
    });

    // Call rename video API
    await userService.renameVideo(videoId, `${videoName}.mp4`, schoolId);

    // Rename video in main library
    dispatch({
      type: ActionTypes.RENAME_VIDEO,
      payload,
    });

    // If the video is part of a playlist, rename it in the playlist
    if (playlistId && !isVideoFromLibrary) {
      dispatch({
        type: ActionTypes.RENAME_VIDEO_FROM_PLAYLIST,
        payload: {
          playlistId,
          videoId,
          videoName: `${videoName}.mp4`,
        },
      });
      // Update video name in selected videos
      const updatedSelectedVideos = selectedVideoPaths.map((video) =>
        video.id === videoId
          ? { ...video, videoName: `${videoName}.mp4` }
          : video
      );
      dispatch({
        type: ActionTypes.SET_SELECTED_VIDEO_PATH,
        payload: updatedSelectedVideos,
      });
    }

    // Update video name in the video library
    dispatch({
      type: VideoLibraryDataTableActionTypes.UPDATE_VIDEO_NAME,
      payload: {
        videoId,
        videoName: `${videoName}.mp4`,
      },
    });
  } catch (err) {
    // Handle error and open fail dialog
    dispatch({
      type: ActionTypes.RENAME_VIDEO,
      payload: err,
    });
    dispatch({
      type: ActionTypes.OPEN_FAIL_DIALOG,
      payload: {
        open: true,
        message: "Something went wrong",
      },
    });
  }
};

export const deleteVideo = (dispatch, payload) => {
  const {
    playlistId = null,
    eventMediaId = null,
    setVideoPath = () => {},
    selectedVideo = null,
    selectedVideoPaths = [],
    tableData = [],
    filteredTableData = [],
    isVideoFromLibrary = false,
  } = payload;

  dispatch({ type: ActionTypes.VIDEO_LIBRARY_LOADING, payload: true });

  if (!eventMediaId) {
    dispatch({
      type: ActionTypes.VIDEO_LIBRARY_LOADING,
      payload: false,
    });
    return;
  }

  userService
    .deleteEditedVideos(eventMediaId)
    .then(() => {
      if (setVideoPath) setVideoPath("");

      // Update selected video if it matches the deleted one, remove from player
      if (selectedVideo?.id === eventMediaId) {
        dispatch({
          type: VideoLibraryDataTableActionTypes.SELECTED_VIDEO_PATH,
          payload: null,
        });
      }

      //remove from highlight playlist
      if (playlistId && !isVideoFromLibrary) {
        dispatch({
          type: ActionTypes.REMOVE_VIDEO_FROM_PLAYLIST,
          payload: {
            playlistId,
            videoId: eventMediaId[0],
          },
        });
        // Remove video from selected video paths
        const updatedSelectedVideoPaths = selectedVideoPaths.filter(
          (path) => path?.id !== eventMediaId[0]
        );
        dispatch({
          type: ActionTypes.SET_SELECTED_VIDEO_PATH,
          payload: updatedSelectedVideoPaths,
        });
      }

      if (payload?.tableData) {
        // Update table data
        const updatedTableData = payload?.tableData?.filter(
          (ele) => ele?.id !== eventMediaId[0]
        );
        dispatch({
          type: VideoLibraryDataTableActionTypes.SET_VIDEO_LIBRARY_TABLE_DATA,
          payload: updatedTableData,
        });
      }

      if (payload?.filteredTableData) {
        // Update filtered table data
        const updatedFilteredData = payload?.filteredTableData?.filter(
          (ele) => ele?.id !== eventMediaId[0]
        );
        dispatch({
          type: VideoLibraryDataTableActionTypes.FILTER_TABLE,
          payload: updatedFilteredData,
        });
      }
      // Show success pop-up and close confirmation
      dispatch({ type: ActionTypes.CLOSE_CONFIRMATION_POPUP, payload: false });
      dispatch({
        type: ActionTypes.OPEN_SUCCESS_POPUP,
        payload: {
          successPopUp: {
            message: "Video Deleted Successfully",
            open: true,
          },
        },
      });
    })
    .catch((err) => {
      // Show failure pop-up
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
    })
    .finally(() => {
      dispatch({ type: ActionTypes.VIDEO_LIBRARY_LOADING, payload: false });
    });
};

export const sendHighlightRequest = (dispatch, payload) => {
  userService
    .saveFinalHighlight(
      payload.videoName,
      payload.videoPath,
      payload.schoolId,
      payload.eventMediaId,
      payload.eventId,
      payload.shareIdForHighlight
    )
    .then((res) => {
      if (res.data.message == "Create Highlight Save Successfully") {
        dispatch({
          type: ActionTypes.CLOSE_CONFIRMATION_POPUP,
          payload: false,
        });
        dispatch({
          type: ActionTypes.OPEN_SUCCESS_POPUP,
          payload: {
            successPopUp: {
              open: true,
              message: "Video Highlight Request Sent Successfully",
            },
          },
        });
      }
    })
    .catch(() => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
    });
};

export const fetchAllSeasonData = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.FETCH_ALL_SEASON_DATA,
    payload: { loading: true },
  });
  userService
    .fetchScheduleList(payload)
    .then((res) => {
      const data = res.data.data;
      let allSeasonData = [];
      for (var key in data) {
        // let inSeason1 = [];
        // let offSeason1 = [];
        // let otherSeason1 = [];
        let highlight1 = [];
        let inSeasonPlaylist = [];
        let offSeasonPlaylist = [];
        let otherSeasonPlaylist = [];

        //in Season data
        // if (data[key].inSeason.length !== 0) {
        //   for (var key2 in data[key].inSeason) {
        //     let game = [];
        //     let practice = [];
        //     let opponentScout = [];
        //     //filtering highlight data for game
        //     if (data[key].inSeason[key2].Game.length !== 0) {
        //       data[key].inSeason[key2].Game.forEach((videoData) => {
        //         let videoWithWeekName = { ...videoData, weekName: key2 };
        //         if (videoData.isEdited) {
        //           highlight1.push(videoWithWeekName);
        //         } else {
        //           game.push(videoWithWeekName);
        //         }
        //       });
        //     }
        //     //filtering highlight data for practice
        //     if (data[key].inSeason[key2].Practice.length !== 0) {
        //       data[key].inSeason[key2].Practice.forEach((videoData) => {
        //         if (videoData.isEdited) {
        //           highlight1.push(videoData);
        //         } else {
        //           practice.push(videoData);
        //         }
        //       });
        //     }
        //     //filtering highlight data for opponent scout
        //     if (data[key].inSeason[key2]["Opponent Scout"].length !== 0) {
        //       data[key].inSeason[key2]["Opponent Scout"].forEach(
        //         (videoData) => {
        //           if (videoData.isEdited) {
        //             highlight1.push(videoData);
        //           } else {
        //             opponentScout.push(videoData);
        //           }
        //         }
        //       );
        //     }
        //     inSeason1.push({
        //       weekName: key2,
        //       game: game,
        //       practice: practice,
        //       opponentScout: opponentScout,
        //     });
        //   }
        // }

        //inSeasonPlaylist
        if (data[key]?.inSeasonPlaylist?.length !== 0) {
          for (var key2 in data[key].inSeasonPlaylist) {
            let gamePlaylist = [];
            let practicePlaylist = [];
            let opponentScoutPlaylist = [];
            //game playlist
            if (data[key]?.inSeasonPlaylist[key2]?.Game?.length !== 0) {
              gamePlaylist = data[key]?.inSeasonPlaylist[key2]?.Game;
            }
            //filtering practice playlist
            if (data[key].inSeasonPlaylist[key2]?.Practice?.length !== 0) {
              practicePlaylist = data[key]?.inSeasonPlaylist[key2]?.Practice;
            }
            if (
              data[key]?.inSeasonPlaylist[key2]["Opponent Scout"]?.length !== 0
            ) {
              opponentScoutPlaylist =
                data[key].inSeasonPlaylist[key2]["Opponent Scout"];
            }
            inSeasonPlaylist.push({
              weekName: key2,
              gamePlaylist: gamePlaylist,
              practicePlaylist: practicePlaylist,
              opponentScoutPlaylist: opponentScoutPlaylist,
            });
          }
        }

        //other season data
        // if (data[key].other.length !== 0) {
        //   for (var key2 in data[key].other) {
        //     let arrData = [];
        //     data[key].other[key2].forEach((videoData) => {
        //       if (videoData.isEdited) {
        //         highlight1.push(videoData);
        //       } else {
        //         arrData.push(videoData);
        //       }
        //     });
        //     otherSeason1.push({
        //       seasonType: key2,
        //       arrData: arrData,
        //     });
        //   }
        // }

        //other Season playlist
        if (data[key]?.otherSeasonPlaylist?.length !== 0) {
          for (var key2 in data[key].otherSeasonPlaylist) {
            let arrData = data[key].otherSeasonPlaylist[key2];
            otherSeasonPlaylist.push({
              seasonType: key2,
              arrData: arrData,
            });
          }
        }
        //off season playlist
        if (data[key]?.offSeasonPlaylist?.length !== 0) {
          for (var key2 in data[key]?.offSeasonPlaylist) {
            let practiceArrayPlaylists = [[]];
            if (
              data[key]?.offSeasonPlaylist[key2]["Practice 1"]?.length !== 0
            ) {
              practiceArrayPlaylists[0] =
                data[key]?.offSeasonPlaylist[key2]["Practice 1"];
            }

            if (
              data[key]?.offSeasonPlaylist[key2]["Practice 2"]?.length !== 0
            ) {
              practiceArrayPlaylists[1] =
                data[key]?.offSeasonPlaylist[key2]["Practice 2"];
            }

            if (
              data[key]?.offSeasonPlaylist[key2]["Practice 3"]?.length !== 0
            ) {
              practiceArrayPlaylists[2] =
                data[key]?.offSeasonPlaylist[key2]["Practice 3"];
            }

            if (
              data[key]?.offSeasonPlaylist[key2]["Practice 4"]?.length !== 0
            ) {
              practiceArrayPlaylists[3] =
                data[key]?.offSeasonPlaylist[key2]["Practice 4"];
            }
            if (
              data[key]?.offSeasonPlaylist[key2]["Practice 5"]?.length !== 0
            ) {
              practiceArrayPlaylists[4] =
                data[key]?.offSeasonPlaylist[key2]["Practice 5"];
            }
            if (
              data[key]?.offSeasonPlaylist[key2]["Practice 6"]?.length !== 0
            ) {
              practiceArrayPlaylists[5] =
                data[key]?.offSeasonPlaylist[key2]["Practice 6"];
            }
            if (
              data[key]?.offSeasonPlaylist[key2]["Practice 7"]?.length !== 0
            ) {
              practiceArrayPlaylists[6] =
                data[key]?.offSeasonPlaylist[key2]["Practice 7"];
            }
            if (
              data[key]?.offSeasonPlaylist[key2]["Practice 8"]?.length !== 0
            ) {
              practiceArrayPlaylists[7] =
                data[key]?.offSeasonPlaylist[key2]["Practice 8"];
            }
            if (
              data[key]?.offSeasonPlaylist[key2]["Practice 9"]?.length !== 0
            ) {
              practiceArrayPlaylists[8] =
                data[key]?.offSeasonPlaylist[key2]["Practice 9"];
            }
            if (
              data[key]?.offSeasonPlaylist[key2]["Practice 10"]?.length !== 0
            ) {
              practiceArrayPlaylists[9] =
                data[key]?.offSeasonPlaylist[key2]["Practice 10"];
            }
            if (
              data[key]?.offSeasonPlaylist[key2]["Practice 11"]?.length !== 0
            ) {
              practiceArrayPlaylists[10] =
                data[key]?.offSeasonPlaylist[key2]["Practice 11"];
            }
            if (
              data[key]?.offSeasonPlaylist[key2]["Practice 12"]?.length !== 0
            ) {
              practiceArrayPlaylists[11] =
                data[key]?.offSeasonPlaylist[key2]["Practice 12"];
            }
            if (
              data[key]?.offSeasonPlaylist[key2]["Practice 13"]?.length !== 0
            ) {
              practiceArrayPlaylists[12] =
                data[key]?.offSeasonPlaylist[key2]["Practice 13"];
            }
            if (
              data[key]?.offSeasonPlaylist[key2]["Practice 14"]?.length !== 0
            ) {
              practiceArrayPlaylists[13] =
                data[key]?.offSeasonPlaylist[key2]["Practice 14"];
            }
            if (
              data[key]?.offSeasonPlaylist[key2]["Practice 15"]?.length !== 0
            ) {
              practiceArrayPlaylists[14] =
                data[key]?.offSeasonPlaylist[key2]["Practice 15"];
            }

            offSeasonPlaylist.push({
              eventName: key2,
              arr: [
                {
                  practiceName: "Practice 1",
                  practiceArrayPlaylist: practiceArrayPlaylists[0],
                },
                {
                  practiceName: "Practice 2",
                  practiceArrayPlaylist: practiceArrayPlaylists[1],
                },
                {
                  practiceName: "Practice 3",
                  practiceArrayPlaylist: practiceArrayPlaylists[2],
                },
                {
                  practiceName: "Practice 4",
                  practiceArrayPlaylist: practiceArrayPlaylists[3],
                },
                {
                  practiceName: "Practice 5",
                  practiceArrayPlaylist: practiceArrayPlaylists[4],
                },
                {
                  practiceName: "Practice 6",
                  practiceArrayPlaylist: practiceArrayPlaylists[5],
                },
                {
                  practiceName: "Practice 7",
                  practiceArrayPlaylist: practiceArrayPlaylists[6],
                },
                {
                  practiceName: "Practice 8",
                  practiceArrayPlaylist: practiceArrayPlaylists[7],
                },
                {
                  practiceName: "Practice 9",
                  practiceArrayPlaylist: practiceArrayPlaylists[8],
                },
                {
                  practiceName: "Practice 10",
                  practiceArrayPlaylist: practiceArrayPlaylists[9],
                },
                {
                  practiceName: "Practice 11",
                  practiceArrayPlaylist: practiceArrayPlaylists[10],
                },
                {
                  practiceName: "Practice 12",
                  practiceArrayPlaylist: practiceArrayPlaylists[11],
                },
                {
                  practiceName: "Practice 13",
                  practiceArrayPlaylist: practiceArrayPlaylists[12],
                },
                {
                  practiceName: "Practice 14",
                  practiceArrayPlaylist: practiceArrayPlaylists[13],
                },
                {
                  practiceName: "Practice 15",
                  practiceArrayPlaylist: practiceArrayPlaylists[14],
                },
              ],
            });
          }
        }
        //off season data
        // if (data[key].offSeason.length !== 0) {
        //   for (var key2 in data[key].offSeason) {
        //     let practiceArrays = [[]];
        //     if (data[key]?.offSeason[key2]["Practice 1"]?.length !== 0) {
        //       let practiceArray1 = [];
        //       data[key]?.offSeason[key2]["Practice 1"]?.forEach((videoData) => {
        //         if (videoData?.isEdited) {
        //           highlight1.push(videoData);
        //         } else {
        //           practiceArray1.push(videoData);
        //         }
        //       });
        //       practiceArrays[0] = practiceArray1;
        //     }

        //     if (data[key]?.offSeason[key2]["Practice 2"]?.length !== 0) {
        //       let practiceArray2 = [];
        //       data[key]?.offSeason[key2]["Practice 2"]?.forEach((videoData) => {
        //         if (videoData?.isEdited) {
        //           highlight1.push(videoData);
        //         } else {
        //           practiceArray2.push(videoData);
        //         }
        //       });
        //       practiceArrays[1] = practiceArray2;
        //     }

        //     if (data[key]?.offSeason[key2]["Practice 3"]?.length !== 0) {
        //       let practiceArray3 = [];
        //       data[key]?.offSeason[key2]["Practice 3"]?.forEach((videoData) => {
        //         if (videoData?.isEdited) {
        //           highlight1.push(videoData);
        //         } else {
        //           practiceArray3.push(videoData);
        //         }
        //       });
        //       practiceArrays[2] = practiceArray3;
        //     }

        //     if (data[key]?.offSeason[key2]["Practice 4"]?.length !== 0) {
        //       let practiceArray4 = [];
        //       data[key]?.offSeason[key2]["Practice 4"]?.forEach((videoData) => {
        //         if (videoData?.isEdited) {
        //           highlight1.push(videoData);
        //         } else {
        //           practiceArray4.push(videoData);
        //         }
        //       });
        //       practiceArrays[3] = practiceArray4;
        //     }
        //     if (data[key]?.offSeason[key2]["Practice 5"]?.length !== 0) {
        //       let practiceArray5 = [];
        //       data[key]?.offSeason[key2]["Practice 5"]?.forEach((videoData) => {
        //         if (videoData?.isEdited) {
        //           highlight1.push(videoData);
        //         } else {
        //           practiceArray5.push(videoData);
        //         }
        //       });
        //       practiceArrays[4] = practiceArray5;
        //     }
        //     if (data[key]?.offSeason[key2]["Practice 6"]?.length !== 0) {
        //       let practiceArray6 = [];
        //       data[key]?.offSeason[key2]["Practice 6"]?.forEach((videoData) => {
        //         if (videoData?.isEdited) {
        //           highlight1.push(videoData);
        //         } else {
        //           practiceArray6.push(videoData);
        //         }
        //       });
        //       practiceArrays[5] = practiceArray6;
        //     }
        //     if (data[key]?.offSeason[key2]["Practice 7"]?.length !== 0) {
        //       let practiceArray7 = [];
        //       data[key]?.offSeason[key2]["Practice 7"]?.forEach((videoData) => {
        //         if (videoData?.isEdited) {
        //           highlight1.push(videoData);
        //         } else {
        //           practiceArray7.push(videoData);
        //         }
        //       });
        //       practiceArrays[6] = practiceArray7;
        //     }
        //     if (data[key]?.offSeason[key2]["Practice 8"]?.length !== 0) {
        //       let practiceArray8 = [];
        //       data[key]?.offSeason[key2]["Practice 8"]?.forEach((videoData) => {
        //         if (videoData?.isEdited) {
        //           highlight1.push(videoData);
        //         } else {
        //           practiceArray8.push(videoData);
        //         }
        //       });
        //       practiceArrays[7] = practiceArray8;
        //     }
        //     if (data[key]?.offSeason[key2]["Practice 9"]?.length !== 0) {
        //       let practiceArray9 = [];
        //       data[key]?.offSeason[key2]["Practice 9"]?.forEach((videoData) => {
        //         if (videoData?.isEdited) {
        //           highlight1.push(videoData);
        //         } else {
        //           practiceArray9.push(videoData);
        //         }
        //       });
        //       practiceArrays[8] = practiceArray9;
        //     }
        //     if (data[key]?.offSeason[key2]["Practice 10"]?.length !== 0) {
        //       let practiceArray10 = [];
        //       data[key]?.offSeason[key2]["Practice 10"]?.forEach(
        //         (videoData) => {
        //           if (videoData?.isEdited) {
        //             highlight1.push(videoData);
        //           } else {
        //             practiceArray10.push(videoData);
        //           }
        //         }
        //       );
        //       practiceArrays[9] = practiceArray10;
        //     }
        //     if (data[key]?.offSeason[key2]["Practice 11"]?.length !== 0) {
        //       let practiceArray11 = [];
        //       data[key]?.offSeason[key2]["Practice 11"]?.forEach(
        //         (videoData) => {
        //           if (videoData?.isEdited) {
        //             highlight1.push(videoData);
        //           } else {
        //             practiceArray11.push(videoData);
        //           }
        //         }
        //       );
        //       practiceArrays[10] = practiceArray11;
        //     }
        //     if (data[key]?.offSeason[key2]["Practice 12"]?.length !== 0) {
        //       let practiceArray12 = [];
        //       data[key]?.offSeason[key2]["Practice 12"]?.forEach(
        //         (videoData) => {
        //           if (videoData?.isEdited) {
        //             highlight1.push(videoData);
        //           } else {
        //             practiceArray12.push(videoData);
        //           }
        //         }
        //       );
        //       practiceArrays[11] = practiceArray12;
        //     }
        //     if (data[key]?.offSeason[key2]["Practice 13"]?.length !== 0) {
        //       let practiceArray13 = [];
        //       data[key]?.offSeason[key2]["Practice 13"]?.forEach(
        //         (videoData) => {
        //           if (videoData?.isEdited) {
        //             highlight1.push(videoData);
        //           } else {
        //             practiceArray13.push(videoData);
        //           }
        //         }
        //       );
        //       practiceArrays[12] = practiceArray13;
        //     }
        //     if (data[key]?.offSeason[key2]["Practice 14"]?.length !== 0) {
        //       let practiceArray14 = [];
        //       data[key]?.offSeason[key2]["Practice 14"]?.forEach(
        //         (videoData) => {
        //           if (videoData?.isEdited) {
        //             highlight1.push(videoData);
        //           } else {
        //             practiceArray14.push(videoData);
        //           }
        //         }
        //       );
        //       practiceArrays[13] = practiceArray14;
        //     }
        //     if (data[key]?.offSeason[key2]["Practice 15"]?.length !== 0) {
        //       let practiceArray15 = [];
        //       data[key]?.offSeason[key2]["Practice 15"]?.forEach(
        //         (videoData) => {
        //           if (videoData?.isEdited) {
        //             highlight1.push(videoData);
        //           } else {
        //             practiceArray15.push(videoData);
        //           }
        //         }
        //       );
        //       practiceArrays[14] = practiceArray15;
        //     }

        //     offSeason1.push({
        //       eventName: key2,
        //       arr: [
        //         {
        //           practiceName: "Practice 1",
        //           practiceArray: practiceArrays[0],
        //         },
        //         {
        //           practiceName: "Practice 2",
        //           practiceArray: practiceArrays[1],
        //         },
        //         {
        //           practiceName: "Practice 3",
        //           practiceArray: practiceArrays[2],
        //         },
        //         {
        //           practiceName: "Practice 4",
        //           practiceArray: practiceArrays[3],
        //         },
        //         {
        //           practiceName: "Practice 5",
        //           practiceArray: practiceArrays[4],
        //         },
        //         {
        //           practiceName: "Practice 6",
        //           practiceArray: practiceArrays[5],
        //         },
        //         {
        //           practiceName: "Practice 7",
        //           practiceArray: practiceArrays[6],
        //         },
        //         {
        //           practiceName: "Practice 8",
        //           practiceArray: practiceArrays[7],
        //         },
        //         {
        //           practiceName: "Practice 9",
        //           practiceArray: practiceArrays[8],
        //         },
        //         {
        //           practiceName: "Practice 10",
        //           practiceArray: practiceArrays[9],
        //         },
        //         {
        //           practiceName: "Practice 11",
        //           practiceArray: practiceArrays[10],
        //         },
        //         {
        //           practiceName: "Practice 12",
        //           practiceArray: practiceArrays[11],
        //         },
        //         {
        //           practiceName: "Practice 13",
        //           practiceArray: practiceArrays[12],
        //         },
        //         {
        //           practiceName: "Practice 14",
        //           practiceArray: practiceArrays[13],
        //         },
        //         {
        //           practiceName: "Practice 15",
        //           practiceArray: practiceArrays[14],
        //         },
        //       ],
        //     });
        //   }
        // }
        allSeasonData.push({
          seasonName: key,
          // inSeasonData: inSeason1,
          // otherSeasonData: otherSeason1,
          // offSeasonData: offSeason1,
          highlight: highlight1,
          inSeasonPlaylist: inSeasonPlaylist,
          otherSeasonPlaylist: otherSeasonPlaylist,
          offSeasonPlaylist: offSeasonPlaylist,
        });
        // inSeason1 = [];
        // otherSeason1 = [];
        // offSeason1 = [];
        highlight1 = [];
        inSeasonPlaylist = [];
        otherSeasonPlaylist = [];
        offSeasonPlaylist = [];
      }
      allSeasonData?.sort((a, b) => {
        var key1 = Number(a.seasonName.substring(0, 4));
        var key2 = Number(b.seasonName.substring(0, 4));
        if (key1 > key2) return -1;
        if (key1 < key2) return 1;
        return 0;
      });
      dispatch({
        type: ActionTypes.FETCH_ALL_SEASON_DATA,
        payload: { allSeasonData, loading: false },
      });
    })
    .catch((error) => {
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
    });
};

export const deleteVideoFromPastSeason = (dispatch, payload) => {
  userService
    .deleteEditedVideos(payload.eventMediaId)
    .then((res) => {
      dispatch({
        type: ActionTypes.DELETE_VIDEO_FROM_PAST_SEASON,
        payload: payload,
      });
      dispatch({
        type: ActionTypes.CLOSE_CONFIRMATION_POPUP,
        payload: false,
      });
      dispatch({
        type: ActionTypes.OPEN_SUCCESS_POPUP,
        payload: {
          successPopUp: {
            message: "Video Deleted Successfully",
            open: true,
          },
        },
      });
    })
    .catch((err) => {
      dispatch({
        type: ActionTypes.DELETE_VIDEO_FROM_PAST_SEASON,
        payload: err,
      });
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
    });
};

export const checkUnCheckSelectedVideo = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.CHECK_UNCHECK_VIDEO,
    payload: payload,
  });
};

export const resetVideoLibraryInitialState = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.RESET_VIDEOLIBRARY_INITIAL_STATE,
    payload: null,
  });
};
